import { render } from "./Shipment.vue?vue&type=template&id=50e6e627&scoped=true"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"

import "./Shipment.vue?vue&type=style&index=0&id=50e6e627&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50e6e627"

export default script